import dayjs from 'dayjs';
/** 堆叠柱状图每一列的圆角只应出现在从上往下第一个非0的分段上 */ const buildStackedBarData = (dataMatrix)=>{
    var _dataMatrix_;
    const length = ((_dataMatrix_ = dataMatrix[0]) === null || _dataMatrix_ === void 0 ? void 0 : _dataMatrix_.length) || 0;
    const topSeriesIndexList = Array.from({
        length
    }, (_, dataIndex)=>{
        let topSeriesIndex = 0;
        for(let seriesIndex = dataMatrix.length - 1; seriesIndex >= 0; seriesIndex--){
            if (Number(dataMatrix[seriesIndex][dataIndex] || 0) > 0) {
                topSeriesIndex = seriesIndex;
                break;
            }
        }
        return topSeriesIndex;
    });
    return dataMatrix.map((values, seriesIndex)=>values.map((value, dataIndex)=>({
                value,
                itemStyle: {
                    borderRadius: topSeriesIndexList[dataIndex] === seriesIndex ? [
                        6,
                        6,
                        0,
                        0
                    ] : [
                        0,
                        0,
                        0,
                        0
                    ]
                }
            })));
};
export const getLineOption = (list, t)=>{
    const safeList = list || [];
    const aiCounts = safeList.map((item)=>Number(item.ai_count || 0));
    const humanCounts = safeList.map((item)=>Number(item.human_count || 0));
    const [aiData, humanData] = buildStackedBarData([
        aiCounts,
        humanCounts
    ]);
    const stackTotals = aiCounts.map((count, index)=>count + humanCounts[index]);
    const showLabel = (safeList === null || safeList === void 0 ? void 0 : safeList.length) <= 61;
    /** 分段占当日总量的占比低于此阈值时不再展示数字，避免小分段挤在一起 */ const MIN_SEGMENT_SHARE = 0.08;
    const barLabelFontSize = (safeList === null || safeList === void 0 ? void 0 : safeList.length) > 30 ? 10 : 12;
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_;
                const item = safeList === null || safeList === void 0 ? void 0 : safeList[params === null || params === void 0 ? void 0 : (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.dataIndex];
                if (!item) return '';
                const total = Number(item.ai_count || 0) + Number(item.human_count || 0);
                const row = (label, value, color)=>`
			<div style="display:flex;justify-content:space-between;margin-bottom:4px">
				<span style="display:flex;align-items:center">
					${color ? `<span style="display:inline-block;width:6px;height:6px;margin-right:6px;border-radius:50%;background-color:${color}"></span>` : ''}
					${label}
				</span>
				<span style="min-width:100px;text-align:right;font-weight:600">
					${value}
				</span>
			</div>
		`;
                return `
			<div>
				<div style="font-weight:600;margin-bottom:8px;">
					${dayjs(item.date).format('YYYY-MM-DD')}
				</div>
                ${row(t('c_a_total_quantity_processed'), total)}
				${row(t('c_a_ai_processing_quantity'), item.ai_count || 0, '#FFC92F')}
				${row(t('c_a_processing_quantity'), item.human_count || 0, '#6CE565')}
				${row(t('c_a_overview_ai_solution_rate'), item.ai_solve_percent || '0%', '#8B5CF6')}
			</div>
		`;
            }
        },
        grid: {
            left: 30,
            right: 20,
            bottom: 10,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: safeList.map((item)=>dayjs(item.date).format('MM.DD'))
        },
        yAxis: [
            {
                type: 'value',
                name: t('c_a_Incoming_line_statistics'),
                min: 0,
                position: 'left',
                axisLabel: {
                    formatter: '{value}'
                },
                splitLine: {
                    show: true
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            },
            {
                type: 'value',
                name: t('c_a_overview_ai_solution_rate'),
                min: 0,
                position: 'right',
                axisLabel: {
                    formatter: '{value}%'
                },
                splitLine: {
                    show: false
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            }
        ],
        series: [
            /** AI处理（底层） */ {
                name: t('c_a_ai_processing_quantity'),
                type: 'bar',
                stack: 'total',
                data: aiData,
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 14 ? 40 : 'auto',
                itemStyle: {
                    color: '#FFC92F'
                },
                label: {
                    show: showLabel,
                    position: 'inside',
                    fontSize: barLabelFontSize,
                    formatter: (params)=>{
                        const total = stackTotals[params.dataIndex] || 0;
                        if (params.value === 0 || total && params.value / total < MIN_SEGMENT_SHARE) return '';
                        return params.value;
                    }
                }
            },
            /** 人工处理（上层） */ {
                name: t('c_a_processing_quantity'),
                type: 'bar',
                stack: 'total',
                data: humanData,
                itemStyle: {
                    color: '#6CE565'
                },
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 14 ? 40 : 'auto',
                label: {
                    show: showLabel,
                    position: 'inside',
                    fontSize: barLabelFontSize,
                    formatter: (params)=>{
                        const total = stackTotals[params.dataIndex] || 0;
                        if (params.value === 0 || total && params.value / total < MIN_SEGMENT_SHARE) return '';
                        return params.value;
                    }
                }
            },
            /** AI解决率 */ {
                name: t('c_a_overview_ai_solution_rate'),
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                    color: '#8B5CF6'
                },
                smooth: true,
                lineStyle: {
                    color: '#8B5CF6'
                },
                areaStyle: {
                    color: 'rgba(139, 92, 246, 0.1)'
                },
                data: safeList.map((item)=>Number(String(item.ai_solve_percent).replace('%', '') || 0)),
                label: {
                    show: showLabel,
                    formatter: (params)=>{
                        return params.value === 0 ? '' : `${params.value}%`;
                    }
                }
            }
        ]
    };
};
export const getTransferReasonOption = (list, t)=>{
    const safeList = list || [];
    const categories = [
        {
            countKey: 'not_switch_count',
            percentKey: 'not_switch_per',
            name: t('c_a_an_jun_reason_1'),
            color: '#6CE565'
        },
        {
            countKey: 'api_data_exception_num',
            percentKey: 'api_data_exception_per',
            name: t('c_a_an_jun_reason_2'),
            color: '#FFC92F'
        },
        {
            countKey: 'sop_required_num',
            percentKey: 'sop_required_per',
            name: t('c_a_an_jun_reason_3'),
            color: '#33CCFF'
        },
        {
            countKey: 'customer_requests_num',
            percentKey: 'customer_requests_per',
            name: t('c_a_an_jun_reason_4'),
            color: '#CCFF00'
        },
        {
            countKey: 'knowledge_gap_num',
            percentKey: 'knowledge_gap_per',
            name: t('c_a_an_jun_reason_5'),
            color: '#A78BFA'
        },
        {
            countKey: 'other_num',
            percentKey: 'other_per',
            name: t('c_a_an_jun_reason_6'),
            color: '#CBD5E1'
        }
    ];
    const dataMatrix = categories.map((cat)=>safeList.map((item)=>Number(item[cat.countKey] || 0)));
    const stackedData = buildStackedBarData(dataMatrix);
    const stackTotals = safeList.map((_, dataIndex)=>dataMatrix.reduce((sum, values)=>sum + (values[dataIndex] || 0), 0));
    const showLabel = (safeList === null || safeList === void 0 ? void 0 : safeList.length) <= 61;
    /** 分段占当日总量的占比低于此阈值时不再展示数字，避免小分段挤在一起 */ const MIN_SEGMENT_SHARE = 0.08;
    const barLabelFontSize = (safeList === null || safeList === void 0 ? void 0 : safeList.length) > 30 ? 10 : 12;
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_, _categories_map;
                const item = safeList === null || safeList === void 0 ? void 0 : safeList[params === null || params === void 0 ? void 0 : (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.dataIndex];
                if (!item) return '';
                const row = (label, value, color)=>`
			<div style="display:flex;justify-content:space-between;margin-bottom:8px">
				<span style="display:flex;align-items:center">
					${color ? `<span style="display:inline-block;width:7px;height:7px;margin-right:6px;border-radius:50%;background-color:${color}"></span>` : ''}
					${label}
				</span>
				<span style="min-width:120px;text-align:right;font-weight:400">
					${value}
				</span>
			</div>
		`;
                return `
			<div>
				<div style="font-weight:600;margin-bottom:8px;">
					${dayjs(item.date).format('YYYY-MM-DD')}
				</div>
                ${categories === null || categories === void 0 ? void 0 : (_categories_map = categories.map((cat)=>row(cat.name, `${item[cat.countKey] || 0} (${item[cat.percentKey] || '0%'})`, cat.color))) === null || _categories_map === void 0 ? void 0 : _categories_map.join('')}
			</div>
		`;
            }
        },
        legend: {
            type: 'scroll'
        },
        grid: {
            left: 30,
            right: 20,
            bottom: 10,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: safeList.map((item)=>dayjs(item.date).format('MM.DD'))
        },
        yAxis: {
            type: 'value',
            // name: t('c_a_Incoming_line_statistics'),
            min: 0,
            axisLabel: {
                formatter: '{value}'
            },
            splitLine: {
                show: true
            },
            nameGap: 24,
            nameTextStyle: {
                padding: [
                    0,
                    0,
                    10,
                    0
                ]
            }
        },
        series: categories.map((cat, index)=>({
                name: cat.name,
                type: 'bar',
                stack: 'reason',
                data: stackedData[index],
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 21 ? 40 : 'auto',
                itemStyle: {
                    color: cat.color
                },
                label: {
                    show: showLabel,
                    position: 'inside',
                    fontSize: barLabelFontSize,
                    formatter: (params)=>{
                        const total = stackTotals[params.dataIndex] || 0;
                        if (params.value === 0 || total && params.value / total < MIN_SEGMENT_SHARE) return '';
                        return params.value;
                    }
                }
            }))
    };
};
export const getWaybillOption = (list, t)=>{
    const safeList = list || [];
    const waybillCounts = safeList.map((item)=>Number(item.waybill_count || 0));
    const [waybillData] = buildStackedBarData([
        waybillCounts
    ]);
    return {
        tooltip: {
            trigger: 'axis',
            formatter: (params)=>{
                var _params_;
                const item = safeList === null || safeList === void 0 ? void 0 : safeList[params === null || params === void 0 ? void 0 : (_params_ = params[0]) === null || _params_ === void 0 ? void 0 : _params_.dataIndex];
                if (!item) return '';
                const row = (label, value, color)=>`
			<div style="display:flex;justify-content:space-between;margin-bottom:4px">
				<span style="display:flex;align-items:center">
					${color ? `<span style="display:inline-block;width:7px;height:7px;margin-right:6px;border-radius:50%;background-color:${color}"></span>` : ''}
					${label}
				</span>
				<span style="min-width:100px;text-align:right;font-weight:600">
					${value}
				</span>
			</div>
		`;
                return `
			<div>
				<div style="font-weight:600;margin-bottom:8px;">
					${dayjs(item.date).format('YYYY-MM-DD')}
				</div>
				${row(t('c_a_check_waybill'), item.waybill_count || 0, '#FFC92F')}
				${row(t('c_a_waybill_rate'), item.waybill_percent || '0%', '#8B5CF6')}
			</div>
		`;
            }
        },
        legend: {},
        grid: {
            left: 30,
            right: 20,
            bottom: 10,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: safeList.map((item)=>dayjs(item.date).format('MM.DD'))
        },
        yAxis: [
            {
                type: 'value',
                name: t('c_a_Incoming_line_statistics'),
                min: 0,
                position: 'left',
                axisLabel: {
                    formatter: '{value}'
                },
                splitLine: {
                    show: true
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            },
            {
                type: 'value',
                name: t('c_a_overview_ai_solution_rate'),
                min: 0,
                position: 'right',
                axisLabel: {
                    formatter: '{value}%'
                },
                splitLine: {
                    show: false
                },
                nameGap: 24,
                nameTextStyle: {
                    padding: [
                        0,
                        0,
                        10,
                        0
                    ]
                }
            }
        ],
        series: [
            /** 运单数量） */ {
                name: t('c_a_check_waybill'),
                type: 'bar',
                data: waybillData,
                itemStyle: {
                    color: '#FFC92F'
                },
                barWidth: (safeList === null || safeList === void 0 ? void 0 : safeList.length) < 14 ? 40 : 'auto',
                label: {
                    show: true,
                    position: 'inside',
                    // color: '#FFF',
                    formatter: (params)=>{
                        return params.value === 0 ? '' : params.value;
                    }
                }
            },
            /** 运单率 */ {
                name: t('c_a_waybill_rate'),
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                itemStyle: {
                    color: '#8B5CF6'
                },
                lineStyle: {
                    color: '#8B5CF6'
                },
                areaStyle: {
                    color: 'rgba(139, 92, 246, 0.1)'
                },
                data: safeList.map((item)=>Number(String(item.waybill_percent).replace('%', '') || 0)),
                label: {
                    show: true,
                    formatter: (params)=>{
                        return params.value === 0 ? '' : `${params.value}%`;
                    }
                }
            }
        ]
    };
};
